// extracted by mini-css-extract-plugin
export default {"container":"Icon_container__wW9uX","icon":"Icon_icon__6mfRs","verticalFlippedIcon":"Icon_verticalFlippedIcon__uZHzZ"};